import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, ViewChild} from '@angular/core';

@Component({
  selector: 'cqme-dropdown',
  standalone: true,
  imports: [],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DropdownComponent {
  @ViewChild('dropdown') dropdown: ElementRef | undefined;
  @Input() actions: { label: string; action: () => void }[] = [];

  close(): void {
    this.dropdown?.nativeElement.hidePopover();
  }
}
